import styled from 'styled-components'

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 24px;
`
export const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
`
export const FileName = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 600;
  color: #4a4a4a;
`
export const SubtitledText = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: 600;
  color: #888888;
  text-decoration: underline;
  cursor: pointer;
`
export const UploadText = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: 400;
  color: #858585;
`
export const AddText = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
`
export const ModalTitle = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.large};
  font-weight: 600;
  color: #4a4a4a;
  text-align: center;
`
export const ModalSubtitle = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 400;
  color: #4a4a4a;
  text-align: center;
`

export const ScrollContainer = styled.div`
  width: 100%;
  display: flex;

  overflow-x: auto;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    background-color: transparent;
    height: 8px;
    border-radius: 20px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #c9c9c9;
    border-radius: 20px;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 48px;

  button {
    background-color: ${({ theme }) => theme.colors.mainBg};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const Buttons = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;

  button {
    width: 40%;
  }
`
